export { PhilosophyCard } from "./PhilosophyCard";
